export default __webpack_public_path__ + "media/Entra.23b0a699.svg";